import React, { Fragment, useEffect, useState, useCallback } from 'react';
import moment from 'moment';

import RadioGroup from 'b2b-ui-components-lib/lib/components/radioGroup';
import Button from 'b2b-ui-components-lib/lib/components/button';
import Datepicker from 'b2b-ui-components-lib/lib/components/datePicker';
import { getRange, isNull, trackAnalytics } from 'common/utils/app.utils';
import { ampmParser, getFetchSlotApiConfig } from 'featureLib/AppointmentEdl/utils';
import { DATE_FORMATS, SEGMENT } from 'featureLib/AppointmentEdl/constants';
import WidgetComponent from './WidgetComponent';
import './index.scss';
import { FormBuilder } from 'featureLib/FormBuilder';
import { CPM_DETAILS_FORM_CONFIG_EDL } from 'featureLib/ConfirmInstallationComponent/constant';
import { getCurrentOrder } from 'tokenGeneration/lead.util';
import { useHistory } from 'react-router-dom';

export const SITE_READINESS_OPTIONS = [
  {
    id: 'Yes',
    displayName: (
      <div className="site_ready_option">
        <div className="title">Yes, the site is ready.</div>
        {/* <div className="sub_title info">Upon order confirmation, our agent will visit the site.</div> */}
      </div>
    )
  },
  {
    id: 'No',
    displayName: (
      <div className="site_ready_option">
        <div className="title">No, the site needs work.</div>
        {/* <div className="sub_title warn">This may delay the installation process.</div> */}
      </div>
    )
  }
];

const DATE_TODAY = new Date();
const DATE_AFTER_1_MONTH = new Date(new Date().getUTCFullYear(), new Date().getUTCMonth() + 1, new Date().getUTCDay());

const MOCK_PARAMS_ENTERPRISE = {
  media: 'FTTH',
  appointmentStartDate: moment(DATE_TODAY).format(DATE_FORMATS.YYYY_MM_DD), //'2023-11-11'
  appointmentEndDate: moment(DATE_AFTER_1_MONTH).format(DATE_FORMATS.YYYY_MM_DD), //'2023-11-11'
  pincode: '122001',
  segment: SEGMENT.ENTERPRISE,
  orderType: 'NEW',
  orderSubType: 'NEW',
  rsuCode: 'PDG'
};
const apiProps = getFetchSlotApiConfig(MOCK_PARAMS_ENTERPRISE).OV;

const EditSiteDetails = ({
  open,
  setOpen = () => {},
  title = 'Edit Site Details',
  sitesData = {},
  setSitesData = () => {},
  selectedLineItem = {},
  onSubmitClick = () => {},
  loader,
  config,
  lineitems
}) => {
  let getDcpFormSchema = CPM_DETAILS_FORM_CONFIG_EDL;
  if (selectedLineItem && selectedLineItem.dcpFirstName) {
    getDcpFormSchema.dcpFirstName.value = selectedLineItem.dcpFirstName;
    getDcpFormSchema.dcpLastName.value = selectedLineItem.dcpLastName;
    getDcpFormSchema.dcpPhoneNumber.value = selectedLineItem.dcpPhoneNumber;
    getDcpFormSchema.dcpEmail.value = selectedLineItem.dcpEmail;
  }
  const [dcpFormSchema, setDcpFormSchema] = useState(getDcpFormSchema);
  const [selectedOption, setSelectedOption] = useState({});
  const [customerNeedByDate, setCustomerNeedByDate] = useState(null);
  const [siteReadyByDate, setSiteReadyByDate] = useState(selectedLineItem?.siteReadinessDate ? new Date(selectedLineItem?.siteReadinessDate) : new Date());
  const [error, setError] = useState('');
  const [showWidget, setShowWidget] = useState(false);
  const history = useHistory();
  const selectedMedia = selectedLineItem?.media;
  const isThirdPartyOr4g5g = selectedMedia === 'Third Party' || selectedMedia === 'TP';
  const appointmentData = {
    appointmentDate: selectedLineItem?.appointmentDate,
    startTime: selectedLineItem?.appointmentStartTime,
    endTime: selectedLineItem?.appointmentEndTime
  };

  const siteReadyByDateDefault = selectedLineItem?.siteReadinessDate;
  const reschedule = new Date(appointmentData?.appointmentDate) > new Date();

  const loggedInUserRole = sitesData?.role;
  const edlEditableFieldsConfig = config?.siebelBulkOrder?.expressDeliveryLink?.editableFields[loggedInUserRole];

  const siteReadinessStatusDisabled = !edlEditableFieldsConfig?.includes('siteReadinessStatus');
  const siteReadinessDateDisabled = !edlEditableFieldsConfig?.includes('siteReadinessDate');
  const customerNeedByDateDisabled = !edlEditableFieldsConfig?.includes('customerNeedByDate');
  const appointmentDateDisabled = !edlEditableFieldsConfig?.includes('appointmentDate');
  const appointmentStartTimeDisabled = !edlEditableFieldsConfig?.includes('appointmentStartTime');
  const appointmentEndTimeDisabled = !edlEditableFieldsConfig?.includes('appointmentEndTime');

  const handleRadioChange = (value) => {
    setSelectedOption(value);
    console.log(value);
    console.log(selectedLineItem);
    const data = history && history.location && history.location.state && history.location.state.orderData;
    trackAnalytics({
      eVar0: `b2b|edl|Internet|buy|site readiness|edit details|site ${value.id === 'No' ? 'not' : ''} ready`,
      prop0: `b2b|edl|${data && data.customerSegment}|${data && data.product}`,
      prop15: data && data.cpmEmail,
      prop17: data && `${data.cpmFirstName} ${data.cpmLastName}`,
      prop14: data && data.cpmPhoneNumber,
      prop35: data && data.accountName,
      prop39: data && data.customerSegment,
      prop40: data && data.product,
      prop37: lineitems && lineitems.orderType,
      prop43: data && data.sites && data.sites.length,
      prop9: lineitems && lineitems.pincode,
      prop36: data && data.accountName,
      prop20: lineitems && lineitems.installationAddress,
      prop10: data && data.orderId,
      prop29: lineitems && lineitems.media,
      prop16: lineitems && lineitems.city,
      prop7: lineitems && `${lineitems.dcpFirstName} ${lineitems.dcpLastName}`,
      prop8: lineitems && lineitems.dcpPhoneNumber,
      prop9: lineitems && lineitems.dcpEmail,
      prop37: lineitems && lineitems.customerNeedByDate,
      prop14: 'yes',
      prop11: `${data && data.cpmFirstName} ${data && data.cpmLastName}`,
      prop12: data && data.cpmPhoneNumber,
      prop13: data && data.cpmEmail
    });
  };

  const handleSubmitClick = () => {
    if (siteReadyByDate > customerNeedByDate && sitesData && sitesData.customerSegment !== 'SMB') {
      setError('Site readiness date cannot be ahead of customer need by date. Choose a date before the selected customer need by date.');
    } else {
      setError('');
      const sitesDataCpy = { ...sitesData };

      sitesDataCpy?.sites?.map((item) => {
        if (item.lsiId === selectedLineItem.lsiId) {
          item.customerNeedByDate = moment(customerNeedByDate).format(DATE_FORMATS.YYYY_MM_DD);
          item.siteReadinessDate = selectedOption?.id === 'Yes' ? null : moment(siteReadyByDate).format(DATE_FORMATS.YYYY_MM_DD);
          item.siteReadinessStatus = selectedOption?.id === 'Yes';
          item.dcpFirstName = dcpFormSchema?.dcpFirstName?.value;
          item.dcpLastName = dcpFormSchema?.dcpLastName?.value;
          item.dcpEmail = dcpFormSchema?.dcpEmail?.value;
          item.dcpPhoneNumber = dcpFormSchema?.dcpPhoneNumber?.value;
        }
      });

      setSitesData(sitesDataCpy);
      onSubmitClick(sitesDataCpy);
    }
  };

  const setDefaultFormData = () => {
    const customerNeedByDate = selectedLineItem?.customerNeedByDate;
    setCustomerNeedByDate(new Date(customerNeedByDate));

    let parsedSiteReadiness = '';
    if (!isNull(selectedLineItem?.siteReadinessStatus)) {
      parsedSiteReadiness = selectedLineItem?.siteReadinessStatus ? 'Yes' : 'No';
    }
    const selectedSiteReadiness = SITE_READINESS_OPTIONS.find((item) => item.id === parsedSiteReadiness) || {};
    setSelectedOption(selectedSiteReadiness);
  };

  const handleOpenWidget = () => {
    setShowWidget(true);
  };

  const handleCustomerNeedByDateChange = (value) => {
    setCustomerNeedByDate(value);

    // update line items
    const sitesDataCpy = { ...sitesData };

    sitesDataCpy?.sites?.map((item) => {
      if (item.lsiId === selectedLineItem.lsiId) {
        item.customerNeedByDate = moment(value).format(DATE_FORMATS.YYYY_MM_DD);
      }
    });

    setSitesData(sitesDataCpy);
  };

  useEffect(() => {
    setDefaultFormData();
    const data = history && history.location && history.location.state && history.location.state.orderData;
    trackAnalytics({
      eVar0: `b2b|edl|Internet|buy|site readiness|edit details|site contact details`,
      prop0: `b2b|edl|${data && data.customerSegment}|${data && data.product}`,
      prop15: data && data.cpmEmail,
      prop17: data && `${data.cpmFirstName} ${data.cpmLastName}`,
      prop14: data && data.cpmPhoneNumber,
      prop35: data && data.accountName,
      prop39: data && data.customerSegment,
      prop40: data && data.product,
      prop37: lineitems && lineitems.orderType,
      prop43: data && data.sites && data.sites.length,
      prop9: lineitems && lineitems.pincode,
      prop36: data && data.accountName,
      prop20: lineitems && lineitems.installationAddress,
      prop10: data && data.orderId,
      prop29: lineitems && lineitems.media,
      prop16: lineitems && lineitems.city,
      prop7: lineitems && `${lineitems.dcpFirstName} ${lineitems.dcpLastName}`,
      prop8: lineitems && lineitems.dcpPhoneNumber,
      prop9: lineitems && lineitems.dcpEmail,
      prop37: lineitems && lineitems.customerNeedByDate,
      prop14: 'yes',
      prop11: `${data && data.cpmFirstName} ${data && data.cpmLastName}`,
      prop12: data && data.cpmPhoneNumber,
      prop13: data && data.cpmEmail
    });
  }, []);

  const getModalTitle = () => {
    if (selectedOption?.id === 'Yes') {
      return reschedule ? 'Reschedule Appointment' : 'Schedule Appointment';
    } else if (selectedOption?.id === 'No') {
      return 'Tentative site readiness date';
    }
  };

  const isSubmitDisabled = () => {
    let isDisabled = false;

    if (
      (selectedOption?.id === 'No' && (isNull(siteReadyByDate) || isNull(customerNeedByDate))) ||
      (selectedOption?.id === 'Yes' &&
        selectedLineItem &&
        selectedLineItem.media !== 'Third Party' &&
        (isNull(appointmentData?.appointmentDate) || isNull(appointmentData?.startTime) || isNull(appointmentData?.endTime) || isNull(customerNeedByDate))) ||
      checkDcpDetails()
    ) {
      isDisabled = true;
    }

    return isDisabled;
  };
  const handleFormFieldChange = ({ field, value, oldValue, newValue, form }) => {
    setDcpFormSchema(form);
  };

  const onFormFieldChange = useCallback((field, value, initialState, { setForm, form, disableAll, oldValue, newValue }) => {
    handleFormFieldChange({ form, field, value, oldValue, newValue });
  }, []);
  const checkDcpDetails = () => {
    let status =
      (dcpFormSchema.dcpFirstName.errors && dcpFormSchema.dcpFirstName.errors.length > 0) ||
      (dcpFormSchema.dcpPhoneNumber.errors && dcpFormSchema.dcpPhoneNumber.errors.length > 0) ||
      (dcpFormSchema.dcpEmail.errors && dcpFormSchema.dcpEmail.errors.length > 0)
        ? true
        : false;
    return status;
  };
  return (
    <div className={`drawer_modal_controller ${open ? 'active' : ''}`}>
      <div className="drawer">
        <div className="drawer_header">
          <div className="drawer_head">
            <div className="title_info">
              <div className="title_heading">{title}</div>
            </div>
          </div>
        </div>
        <div className="drawer_body">
          <div className="scroll_content">
            <div className="site_readiness">
              <div className="form_section">
                {/**
                 * LEFT PANEL
                 */}
                <div className="leftpanel-container">
                  <div className="box">
                    <div className="title">Installation Details</div>
                    <div className="value">{selectedLineItem?.installationAddress || '-'}</div>
                  </div>

                  <div className="box">
                    <div className="title">Company Project Manager</div>
                    <div className="sub_value bold">{(sitesData?.cpmFirstName || '-') + '' + (sitesData?.cpmLastName || '-')}</div>
                    <div className="sub_value light">{sitesData?.cpmPhoneNumber || '-'}</div>
                    <div className="sub_value light">{sitesData?.cpmEmail || '-'}</div>
                  </div>

                  <div className="box">
                    <div className="title">You can edit Customer Need by Date, Site Readiness and Appointment </div>
                  </div>
                </div>

                {/**
                 * MAIN PANEL
                 */}
                <div className="mainpanel-container">
                  {/* <div className="customer-need-by-date-section">
                    <h4 className="heading">Customer Need by Date</h4>
                    <Datepicker
                      name="datepicker"
                      label="Customer Need by Date"
                      required={true}
                      errors={[]}
                      touched={false}
                      value={customerNeedByDate}
                      onChange={handleCustomerNeedByDateChange}
                      maxDate={new Date(new Date().setYear(new Date().getFullYear() + 5))}
                      minDate={new Date()}
                      years={getRange(new Date().getFullYear(), new Date().getFullYear() + 5)}
                      disabled={false}
                    />
                  </div> */}
                  <div className="site-readiness-section">
                    <div className="action_section">
                      <div className="heading">Site Contact Details</div>
                      <div className="content">
                        <div className="row">
                          <FormBuilder formConfig={dcpFormSchema} onChange={onFormFieldChange} onSubmit={() => {}} />
                        </div>
                      </div>
                    </div>
                    <h4 className="heading">Site Readiness</h4>
                    <div className="info_section">
                      <div className="content">
                        <div className="content_title">For smooth &amp; fast installation, please ensure:</div>
                        <div className="item_title"> Server room is ready with:</div>
                        <ul className="requirement_details">
                          <li>
                            <i className="aeh-icon-tick"></i> Space &amp; rack for server setup
                          </li>
                          <li>
                            <i className="aeh-icon-tick"></i> Proper Voltage (220V – 240V) with Earthing (0.1V - 2V)
                          </li>
                          <li>
                            <i className="aeh-icon-tick"></i> Uninterrupted power supply (UPS)
                          </li>
                        </ul>
                        <div className="item_title">Permission available for:</div>
                        <ul className="requirement_details">
                          <li>
                            <i className="aeh-icon-tick"></i> Pole or tower Installation with access to rooftop (only for wireless)
                          </li>
                          <li>
                            <i className="aeh-icon-tick"></i> In-building wiring
                          </li>
                        </ul>
                      </div>
                    </div>

                    <div className="action_section">
                      <div className="title">Is the site ready for installation?</div>
                      <div className="content">
                        <RadioGroup options={SITE_READINESS_OPTIONS} value={selectedOption} onChange={handleRadioChange} disabled={loader || siteReadinessStatusDisabled} />

                        {selectedOption?.id === 'Yes' && !isThirdPartyOr4g5g && (
                          <div className="selected_appointment">
                            {appointmentData?.appointmentDate &&
                              appointmentData?.startTime &&
                              appointmentData?.endTime &&
                              new Date(appointmentData?.appointmentDate) >= new Date() && (
                                <div className="info">
                                  Appointment is scheduled for{' '}
                                  <div className="value">
                                    <span>
                                      <i className="aeh-icon-outlined-calendar" /> {moment(appointmentData?.appointmentDate).format(DATE_FORMATS.DD_MMM_YYYY)}
                                    </span>
                                    <span>
                                      <i className="aeh-icon-outlined-clock-icon" /> {ampmParser(appointmentData?.startTime)} - {ampmParser(appointmentData?.endTime)}
                                    </span>
                                  </div>
                                </div>
                              )}
                            <div className="action">
                              <Button
                                className="outline-btn"
                                onClick={handleOpenWidget}
                                variant="outlinebtn"
                                disabled={loader || appointmentDateDisabled || appointmentStartTimeDisabled || appointmentEndTimeDisabled}
                              >
                                {reschedule ? 'Reschedule Appointment' : 'Schedule Appointment'}
                              </Button>
                            </div>
                          </div>
                        )}
                        {selectedOption?.id === 'No' && (
                          <Fragment>
                            <div className="selected_appointment">
                              {siteReadyByDateDefault && (
                                <div className="info">
                                  Tentative Site Readiness Date{' '}
                                  <div className="value">
                                    <span>
                                      <i className="aeh-icon-outlined-calendar" /> {moment(siteReadyByDateDefault).format(DATE_FORMATS.DD_MMM_YYYY)}
                                    </span>
                                  </div>
                                </div>
                              )}
                              {/* <div className="action">
                              <Button className="outline-btn" onClick={handleOpenWidget} variant="outlinebtn">
                                Change Date
                              </Button>
                            </div> */}
                            </div>
                            <div className="customer-need-by-date-section">
                              <h4 className="heading">Tentative site readiness date</h4>
                              <Datepicker
                                name="datepicker"
                                label="Tentative site readiness date"
                                required={true}
                                errors={[]}
                                touched={false}
                                value={siteReadyByDate}
                                onChange={(value) => setSiteReadyByDate(value)}
                                maxDate={new Date(new Date().setYear(new Date().getFullYear() + 5))}
                                minDate={new Date()}
                                years={getRange(new Date().getFullYear(), new Date().getFullYear() + 5)}
                                disabled={loader || siteReadinessDateDisabled}
                              />
                              <div className="error-msg">{error}</div>
                              {/* <div className="button_group">
                                <Button disabled={siteReadyByDate === undefined || customerNeedByDate === undefined} onClick={handleSiteReadyByDateSubmit}>
                                  Confirm{' '}
                                </Button>
                              </div> */}
                            </div>
                          </Fragment>
                        )}
                        <div className={`customer-need-by-date-section ${sitesData && sitesData.customerSegment === 'SMB' ? 'hide' : ''}`}>
                          <h4 className="heading">Customer Need by Date</h4>
                          <Datepicker
                            name="datepicker"
                            label="Customer Need by Date"
                            required={true}
                            errors={[]}
                            touched={false}
                            value={customerNeedByDate ? new Date(customerNeedByDate) : new Date()}
                            onChange={handleCustomerNeedByDateChange}
                            // onChange={value =>  setCustomerNeedByDate(value)}
                            maxDate={new Date(new Date().setYear(new Date().getFullYear() + 5))}
                            minDate={new Date()}
                            years={getRange(new Date().getFullYear(), new Date().getFullYear() + 5)}
                            disabled={loader || customerNeedByDateDisabled}
                          />
                        </div>
                      </div>
                      {/* <div className="btn_action schedule_appointment">
                        {selectedOption.id == 'Yes' ? (
                          <Button onClick={() => setShowWidget(true)} variant="outlinebtn" buttonClass="btnClass">
                            Reschedule Appointment
                          </Button>
                        ) : (
                          <Datepicker
                            name="datepicker"
                            label="Site Ready by Date"
                            required={true}
                            errors={[]}
                            touched={false}
                            value={customerNeedByDate}
                            onChange={(value) => setCustomerNeedByDate(value)}
                            maxDate={new Date(new Date().setYear(new Date().getFullYear() + 5))}
                            minDate={new Date()}
                            years={getRange(new Date().getFullYear(), new Date().getFullYear() + 5)}
                            disabled={false}
                          />
                        )}
                      </div> */}
                    </div>

                    <div className="widget-section">
                      {showWidget && lineitems && (
                        <WidgetComponent
                          open={showWidget}
                          setOpen={setShowWidget}
                          title={getModalTitle()}
                          sitesData={sitesData}
                          setSitesData={setSitesData}
                          selectedOption={selectedOption}
                          selectedLineItem={selectedLineItem}
                          reschedule={reschedule}
                          onSubmitClick={onSubmitClick}
                          customerNeedByDate={customerNeedByDate}
                          setCustomerNeedByDate={setCustomerNeedByDate}
                          loader={loader}
                          dcpFormSchema={dcpFormSchema}
                          lineitems={lineitems}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="drawer_footer">
          <div className="button_group">
            <Button
              variant="outlinebtn"
              onClick={() => {
                setOpen(false);
              }}
            >
              Cancel
            </Button>
            <Button disabled={loader || isSubmitDisabled()} onClick={handleSubmitClick}>
              Save{loader && <span className="loading_icon"></span>}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditSiteDetails;
